import { render } from "./wizard.vue?vue&type=template&id=4b0b7e2a"
import script from "./wizard.vue?vue&type=script&lang=js"
export * from "./wizard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Cfcu.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__